import React from "react";
import { useDispatch, useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { WHOLESALER_RETENTIONS_LABELS } from "./labels";
import { formatNumber } from "helpers/getNumberFormats";
import { ActionsButtons } from "components/CustomButtons/ActionsButtons";
import { useToggle } from "hooks/useToggle";
import { ModalV2 } from "components/Modal/ModalV2";
import CardTable from "components/CardTable/CardTable";
import { getRetentionsByGroups } from "redux/actions/wholesalerRetentions/wholesalerRetentionsActions";
import { detailColumns } from "./detailColumns";
import ListIcon from '@mui/icons-material/List';

const { headers, tooltips } = WHOLESALER_RETENTIONS_LABELS;

const ActionsCell = ({ original }) => {
  const dispatch = useDispatch();
  const [open, toggle] = useToggle();
  const { station, month, year, retentionDetails } = useSelector((s) => s.wholesalerRetentions);
  const { isLoadingComp } = useSelector(({ search }) => search);

  const handleView = () => {
    dispatch(
      getRetentionsByGroups({
        station,
        month,
        year,
        idCustomer: original.idCustomer,
      })
    );
    toggle();
  };

  const buttons = [
    {
      Icon: VisibilityIcon,
      color: 0,
      onClick: handleView,
      tooltip: tooltips.viewDetail,
    },
  ];

  return (
    <>
      <ActionsButtons buttons={buttons} />
      <ModalV2 open={open} onClose={toggle} title={`Detalle - ${original.customerName}`} toRight>
        <CardTable
          hasHeader
          icon={<ListIcon />}
          title={'Liquidaciones'}
          data={retentionDetails}
          columns={detailColumns}
          isLoading={isLoadingComp?.loadingRetentionsByGroup}
          blockBtn
          defaultPageSize={10}
        />
      </ModalV2>
    </>
  );
};

export const columns = () => [
  {
    Header: headers.customerName,
    accessor: "customerName",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row?.customerName || "").toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: headers.unit,
    accessor: "unit",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row?.unit || "").toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: headers.month,
    accessor: "month",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row?.month || "").includes(filter.value),
  },
  {
    Header: headers.year,
    accessor: "year",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row?.year || "").includes(filter.value),
  },
  {
    Header: headers.amount,
    accessor: "amount",
    filterable: true,
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
    filterMethod: (filter, row) =>
      String(row?.amount || "").includes(filter.value),
  },
  {
    Header: headers.actions,
    filterable: false,
    Cell: ActionsCell,
  },
];
